import angular from 'angular';

/* @ngInject */ export function MenuServiceFactory($injector) {
  var $svc = {};
  var $svcs = { $svc: $svc };

  $svc.displayApp = $injector.invoke(displayApp, null, $svcs);
  $svc.findOption = $injector.invoke(findOption, null, $svcs);
  $svc.getAppMenuID = $injector.invoke(getAppMenuID, null, $svcs);
  $svc.isFlashEnabled = $injector.invoke(isFlashEnabled, null, $svcs);

  return $svc;
}

/***************************************************************************
 * $svc.displayApp */
/**
 * Display the item selection. For the 'WIN' types, the query string is
 * removed as it contains swfflags and the querystring is rebuild with the
 * menu ID and the dateStamp from the original url.
 *
 * @param  item  Item to be displayed
 ***************************************************************************/
/* @ngInject */ function displayApp(Session) {
  return function (item) {
    switch (item.type) {
      /*--------------------------------------*/
      /* App Page - Insert the menu ID before */
      /* any of the parameters (datestamp).   */
      /*--------------------------------------*/
      case 'WIN':
        var parts = item.url.split('?');
        var path = parts.shift();
        var parms = parts.shift();

        window.location.href = Session.getSessionURL(
          '{0}?mID={1}{2}'.format(path, item.menuID, parms ? '&' + parms : '')
        );
        break;

      /*--------------------------------------*/
      /* New Window - Open URL in new window. */
      /*--------------------------------------*/
      case 'NEW':
        window.open(item.url);
        break;
    }
  };
}

/***************************************************************************
 * $ctrl.findOption */
/**
 * Searches for a menu option by `name` in the books menu. Throws exception
 * if the menu can't be loaded or the option is not found.
 *
 * @param  {string} name  Menu option `name` from Access Control.
 * @return {promise}      Resolved with option object.
 ***************************************************************************/
/* @ngInject */ function findOption($q, $interval) {
  return function (name) {
    /*----------------------------*/
    /* Wait for the menu to load. */
    /*----------------------------*/
    return (
      $q((resolve) => {
        var wait = $interval(
          (i) => {
            var $ctrl = (
              angular
                .element(document.querySelector('books-menu .menucontent'))
                .scope() || {}
            ).$ctrl;
            if ($ctrl.menu) {
              $interval.cancel(wait);
              resolve($ctrl.menu);
            }
          },
          100,
          100
        );
        wait.then(() => {
          throw 'MenuService: books-menu content could not be loaded.';
        });
      })
        /*----------------------------------------------*/
        /* Recurse through the menu to find the option. */
        /*----------------------------------------------*/
        .then((menu) => {
          var option = (function findInMenu(menu) {
            var option = undefined;
            for (var o of menu)
              if (
                (option =
                  o.name === name
                    ? o
                    : o.submenu
                      ? findInMenu(o.submenu)
                      : undefined)
              )
                break;
            return option;
          })(menu);

          if (option) return option;
          throw `MenuService: books-menu option '${name}' not found.`;
        })
    );
  };
}

/***************************************************************************
 * $svc.getAppMenuID */
/**
 * Parses the current window location and returns the menu ID (mID). Returns
 * 0 if none found.
 ***************************************************************************/
/* @ngInject */ function getAppMenuID() {
  return function () {
    var match = /mID=(\d+)/i.exec(window.location.search);
    return match ? match[1] : 0;
  };
}

/***************************************************************************
 * $svc.isFlashEnabled */
/**
 * Will return true is flash is enabled in the browser, false otherwise
 ***************************************************************************/
/* @ngInject */ function isFlashEnabled() {
  return function () {
    var hasFlash = false;
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) hasFlash = true;
    } catch (e) {
      if (
        navigator.mimeTypes &&
        navigator.mimeTypes['application/x-shockwave-flash'] != undefined &&
        navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin
      ) {
        hasFlash = true;
      }
    }
    return hasFlash;
  };
}
